import React from "react"
import { compose, withProps } from "recompact"
import eventResources from "src/hocs/eventResources"
import EventCard from "./EventCard"

export default compose(
  withProps(props => ({ eventUuid: props.data.originId || props.data.uuid })),
  eventResources(),
)(props => (
  <div>
    <EventCard {...props} />
  </div>
))
